import { postCall, getCall, putCall } from "./api";

// Expense Category 

export const createPolicyCateogary = async (input = {}) => {
  return await postCall({ path: `/policy-cateogary`, bodyParams: input, });
};

export const getAllExpenseCategory = async (legalUnit) => {
  console.log(legalUnit);
  return await getCall({ path: `/policy-cateogary/${legalUnit}?type=ANY`, });
};

export const getAllExpensePolicy = async (legalUnit) => {
  return await getCall({ path: `/policy/${legalUnit}?type=ANY`, });
};

export const getPolicyCateogaryByLegalUnit = async (legalUnit) => {
  return await getCall({ path: `/policy-cateogary/${legalUnit}`, });
};

export const createPolicy = async (input = {}) => {
  return await postCall({ path: `/policy`, bodyParams: input, });
};

// publish a draft expense policy → active (claimable)
export const publishPolicy = async (policyId) =>
  await putCall({ path: `/policy/publish/${policyId}`, bodyParams: {} });

export const linkPolicy = async (policyId, input = {}) => {
  return await putCall({ path: `/policy/link/${policyId}`, bodyParams: input, });
};

export const unlinkPolicy = async (policyId, input = {}) => {
  return await putCall({ path: `/policy/remove/${policyId}`, bodyParams: input, });
};

export const getPolicyById = async (policyId) => {
  console.log(policyId);
  return await getCall({ path: `/policy/id/${policyId}`, });
};

export const getPolicySelf = async () => {
  return await getCall({ path: `/policy/self`, });
};



//approve and reject

export const approveExpense = async (input={}, id) => {
  return await putCall({ path: `/expense/approve/${id}`, bodyParams: input, });
};

export const rejectExpense = async (input={}, id) => {
  return await putCall({ path: `/expense/reject/${id}`, bodyParams: input, });
};


//all expense
export const getAllExpense = async () => {
  return await getCall({ path: `/expense/organization`, });
};

export const getExpenseById = async (id) => {
  return await getCall({ path: `/expense/${id}`, });
};

export const getEmployeeExpense = async () => {
  return await getCall({ path: `/expense/employee`, });
};


//create expense by employee

export const createExpense = async (input = {}) => {
  return await postCall({ path: `/expense`, bodyParams: input, });
};